import uiRouter from '@uirouter/angularjs';

import { Auth0SdkServiceModule } from 'services/auth/auth0sdk.service';
import { NativePlatformServiceModule } from 'services/access/nativePlatform/nativePlatform.service';
import { LOGIN_PASSWORD_EXPIRED_COOKIE, LOGIN_REDIRECT_COOKIE } from 'app/constants';

export const Auth0AuthServiceModule = angular
    .module('app.services.auth.auth0AuthService', [
        uiRouter,
        NativePlatformServiceModule,
        Auth0SdkServiceModule
    ])
    .service('auth0AuthService', (
        $q,
        $window,
        $location,
        $state,
        $cookies,
        nativePlatformService,
        auth0SdkService
    ) => {
        function redirectToLogin(shouldResetPassword) {
            const redirectPath = $window.location.pathname === '/error' ? '' : $window.location.pathname;
            $cookies.put(LOGIN_REDIRECT_COOKIE, redirectPath);
            $cookies.put(LOGIN_PASSWORD_EXPIRED_COOKIE, shouldResetPassword);
            nativePlatformService.logout($window);
            logout();
        }

        function unauthenticatedHandler(query, $match) {
            const errorDescription = $location.search().error_description || '';
            const shouldResetPassword = query && query.includes('state') && query.includes('error')
                && errorDescription.startsWith('E001 - ');
            const shouldParseResult = query && query.includes('code=') && query.includes('state=');

            if (shouldParseResult) {
                auth0SdkService.handleRedirectCallback().then(() => {
                    const redirect = $cookies.get(LOGIN_REDIRECT_COOKIE);
                    $cookies.remove(LOGIN_REDIRECT_COOKIE);
                    if (redirect && redirect.length > 1 && redirect.charAt(0) === '/') {
                        const redirectUrl = new URL(redirect, process.env.BASE_ADMIN_URL);
                        const params = Object.fromEntries(redirectUrl.searchParams);

                        if (redirectUrl.pathname === '/checkout') {
                            $state.transitionTo(redirectUrl.pathname.substring(1), params);
                        } else {
                            $window.location.href = redirect;
                        }
                    } else {
                        $state.transitionTo('dashboard', $match, false);
                    }
                });
            } else {
                auth0SdkService.getTokenSilently().then((token) => {
                    if (!token) {
                        redirectToLogin(shouldResetPassword);
                    }
                }).catch(() => {
                    redirectToLogin(shouldResetPassword);
                });
            }
        }

        function auth0login(email) {
            clearLegacyUserCookies();

            auth0SdkService.loginWithRedirect({
                redirect_uri: `${$window.location.protocol}//${$window.location.host}`,
                audience: process.env.AUTH0_AUDIENCE,
                login_hint: email
            });
        }

        function googleLogin() {
            clearLegacyUserCookies();

            auth0SdkService.loginWithRedirect({
                redirect_uri: `${$window.location.protocol}//${$window.location.host}`,
                audience: process.env.AUTH0_AUDIENCE,
                connection: 'google-oauth2'
            });
        }

        function isAuthenticated() {
            clearLegacyUserCookies();
            return auth0SdkService.isAuthenticated();
        }

        function getTokenSilently() {
            clearLegacyUserCookies();
            return auth0SdkService.getTokenSilently();
        }

        function getUser() {
            clearLegacyUserCookies();
            return auth0SdkService.getUser();
        }

        function getRootDomain(hostname) {
            let parts = hostname.split('.');
            let hasSubdomain = parts.length === 3;
            return hasSubdomain ? `${parts[1]}.${parts[2]}` : hostname;
        }

        function clearLegacyUserCookies() {
            $window.localStorage.removeItem('user');
            if (!$cookies.get('id_token')) {
                return;
            }
            const rootDomain = getRootDomain($location.host());
            $cookies.put('id_token', '', { secure: true, domain: rootDomain });
            $cookies.put('access_token', '', { secure: true, domain: rootDomain });
            $cookies.remove('id_token', { domain: rootDomain });
            $cookies.remove('access_token', { domain: rootDomain });
        }

        function logout() {
            clearLegacyUserCookies();
            $cookies.remove(LOGIN_REDIRECT_COOKIE);

            return auth0SdkService.logout({
                client_id: process.env.AUTH0_CLIENT_ID,
                returnTo: `${$window.location.protocol}//${$window.location.host}/login`
            });
        }

        return {
            auth0login,
            clearLegacyUserCookies,
            isAuthenticated,
            getTokenSilently,
            getUser,
            googleLogin,
            logout,
            unauthenticatedHandler
        };
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/auth/auth0auth.service.js